import React, { useState } from 'react';
import { reduxForm } from 'redux-form'; // Import reduxForm
import { FormElems } from 'components';
import FileUploadField from '../FileUploadField';
import './mleMakerChecker.scss';

const LegalInputs = ({ handleSubmit }) => {
  const [jiraLink, setJiraLink] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [remarks, setRemarks] = useState('');
  const [docUrls, setDocUrls] = useState({});

  const item = {
    docType: 'agreement',
    label: 'Upload Agreement',
  };

  const handleViewClick = (docType) => {
    console.log(`View clicked for document type: ${docType}`);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="legal-inputs-wrapper">
        <h2 className="title">Legal Inputs - MLE Onboarding</h2>

        <div className="form-group">
          {/* JIRA Link Input */}
          <div className="input-container">
            <input
              type="text"
              id="jira-link"
              placeholder="Enter JIRA Link"
              value={jiraLink}
              onChange={(e) => setJiraLink(e.target.value)}
            />
          </div>

          {/* Upload Agreement */}
          <div className="input-container">
            <FileUploadField
              itemInfo={item}
              handleViewClick={() => handleViewClick(item.docType)}
              docUrls={docUrls}
              setDocUrls={setDocUrls}
              isViewMode={true}
            />
          </div>
        </div>

        <div className="form-group">
          {/* Agreement Expiry Date */}
          <div className="input-container">
            <label htmlFor="expiry-date">Agreement Expiry Date</label>
            <input
              type="date"
              id="expiry-date"
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
            />
          </div>
        </div>

        {/* Remarks */}
        <div>
          <input
            className='endremarks'
            placeholder="Enter Remarks."
            onChange={(e) => setRemarks(e.target.value)}
          />
        </div>

        {/* Buttons */}
        <div className="form-checkersection">
          <FormElems.Button buttonType="secondary" text="Cancel" id="back-btn" />
          <FormElems.Button buttonType="primary" text="Proceed" id="next-btn" />
        </div>
      </div>
    </form>
  );
};

// Wrap with reduxForm
export default reduxForm({
  form: 'legalInputs', // Unique form name
})(LegalInputs);
